import React from 'react';
import { DetailsRow } from 'structure/staking/components/DetailRow';
import { StakingPool, WithdrawCalculation } from 'api/StakingAPI';
import { mapWithdrawCalculation } from 'structure/staking/utils/mapCalculation';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type WithdrawDetailsProps = {
  pool: StakingPool;
  loading?: boolean;
  calculation: WithdrawCalculation;
};

export function WithdrawDetails({
  pool,
  loading = false,
  calculation,
}: WithdrawDetailsProps) {
  const { t } = useTranslation('common');
  const data = mapWithdrawCalculation(pool, calculation);

  return (
    <div
      className={twMerge(loading ? 'animate-pulse' : '', 'flex flex-col gap-3')}
    >
      <DetailsRow
        label={t('STAKING.CALCULATION')}
        value={`${data.withdrawFeePercentage}% * ${t('STAKING.DAYS_LEFT')}`}
      />
      <DetailsRow
        label={t('STAKING.DAYS_LEFT')}
        value={`${data.daysLeft} ${t('day', { count: parseInt(data.daysLeft, 10) })}`}
      />
      <DetailsRow
        label={t('STAKING.EARLY_WITHDRAW_PENALTY')}
        labelClassName='text-[#FB5656]'
        valueClassName='text-[#FB5656]'
        value={`${t('tokenAmount', { value: data.penalty, maximumFractionDigits: 5 })} ${pool.depositTokenSymbol}`}
      />
    </div>
  );
}
